import { Link } from "react-router-dom";
import React from "react";

export function CardLinkBody({ link, className, children }) {
  if(!link) {
    return <div className={className}>
      {children}
    </div>
  }

  return <Link
    to={link}
    className={className}
    style={{ textDecoration: "none", color: "black" }}>
    {children}
  </Link>;
}